import Vue from "vue";
const course = {
  state: () => ({
    courseVideoList: [], //editVideoList
    VideoFromTopicList: [],
    editCourse: false
  }),

  getters: {
    courseVideoList(state) {
      return state.courseVideoList;
    },
    VideoFromTopicList(state) {
      return state.VideoFromTopicList;
    },
    editCourse(state) {
      return state.editCourse;
    }
  },

  mutations: {
    changeEditAssignment(state, data) {
      state.editCourse = data;
    },
    saveVideoFromTopicList(state, data) {
      state.VideoFromTopicList = data;
    },

    removeVideoFromTopicList(state) {
      state.VideoFromTopicList = [];
    },

    addInCourseVideoList(state, data) {
      let number = state.courseVideoList.length ?? 0;
      data.forEach((videoData, i) => {
        const videoWithNumber = {
          ...videoData,
          imgBlobUrl: videoData.pictureBackground, // to store blob url...
          no: number + (i + 1) // Set the `no` based on current length
        };
        state.courseVideoList.push(videoWithNumber);
      });
    },

    updateInCourseVideoList(state, updatedData) {
      for (let item of state.courseVideoList) {
        if (item.no == updatedData.no) {
          item.no = updatedData.no;
          item.id = updatedData.id;
          item.assignmentCourseID = updatedData.assignmentCourseID;
          item.oldID = updatedData.oldID;
          item.oldVideoID = updatedData.oldVideoID;
          item.startContentDate = updatedData.startContentDate;
          item.endContentDate = updatedData.endContentDate;
          item.videoName = updatedData.videoName;
          item.title = updatedData.title;
          item.description = updatedData.description;
          item.size = updatedData.size;
          item.duration = updatedData.duration;
          item.popupTime = updatedData.popupTime;
          item.videoFile = updatedData.videoFile;
          item.pictureBackground = updatedData.pictureBackground;
          item.allowDownload = updatedData.allowDownload;
          item.imgBase64 = updatedData.pictureBackground;
          item.permissionList = updatedData.permissionList;
          item.imgBlobUrl = updatedData.imgBlobUrl; // for image url type
        }
      }
    },

    removeCourseVideoList(state) {
      state.courseVideoList = [];
    }
  }
};
function Duration(duration) {
  let time = [Math.floor(duration / 60) + "", Math.floor(duration % 60) + ""];
  time.forEach(value => {
    while (value.length < 2) value = "0" + value;
  });
  return `${time[0]}:${time[1]}`;
}
export default course;
